<template>
  <section
    class="
      grid-cols-header-view-mobile
      grid-areas-header-view-mobile
      md:grid-cols-header-view-tablet
      md:grid-areas-header-view-tablet
      lg:grid-areas-header-view-desktop
      relative
      grid
      auto-rows-max
      px-4
      sm:px-8
      md:px-0
    "
  >
    <slot />
  </section>
</template>
